import { DSText } from '@vr/ds-react'
import { Controller, useFormContext } from 'react-hook-form'

import { IItemDateProps } from './interface'
import { DatePeriodSelect } from '@/components/date-period-select'
import { formatDateToBR } from '@/utils/format-date-to-br'
import { getLast31DaysPeriod } from '@/utils/get-last-31-days-period'

const ItemDate = ({ methods }: IItemDateProps) => {
  const { setValue } = useFormContext()

  const changeValue = (value: string) => {
    if (!value) return getLast31DaysPeriod()

    const [startStr, endStr] = value.split(' - ')

    const startBR = formatDateToBR(new Date(startStr))
    const endBR = formatDateToBR(new Date(endStr))

    return startBR + ' - ' + endBR
  }

  return (
    <>
      <Controller
        name='dataDoItem'
        control={methods.control}
        rules={{
          required: 'Data do item é obrigatório',
          validate: value => {
            const [startStr, endStr] = value.split(' - ')
            const start = new Date(startStr)
            const end = new Date(endStr)
            const diffInMs = Math.abs(end.getTime() - start.getTime())
            const diffInDays = diffInMs / (1000 * 60 * 60 * 24)
            return diffInDays <= 31 || 'O intervalo deve ter no máximo 31 dias'
          }
        }}
        render={({ field }) => (
          <DatePeriodSelect
            label='Data do item'
            onChange={({ rangeValues }) => {
              field.onChange(rangeValues.start + ' - ' + rangeValues.end)
              setValue('operadora', null)
              setValue('grupoEconomico', null)
              setValue('unidade', null)
            }}
            value={changeValue(field.value)}
          />
        )}
      />
      <DSText
        as='span'
        size='sm'
        weight={methods.formState.errors.dataDoItem ? 'semibold' : 'regular'}
        color={methods.formState.errors.dataDoItem ? 'errorLight' : 'neutralMedium'}
      >
        * O período máximo de consulta é de 31 dias.
      </DSText>
    </>
  )
}

export default ItemDate
